import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { VStack, Text, Skeleton } from 'wss3-forge'
import { useDocStructure } from '../components/DocsLayout'

export function DocsPlugin() {
  const { pluginSlug } = useParams<{ pluginSlug: string }>()
  const navigate = useNavigate()
  const { structure, loading } = useDocStructure()

  useEffect(() => {
    if (!loading && structure) {
      // Redirect to first page
      const firstSection = structure.sections[0]
      if (firstSection && firstSection.pages && firstSection.pages.length > 0) {
        const firstPage = firstSection.pages[0]
        navigate(`/${pluginSlug}/${firstSection.slug}/${firstPage.slug}`, { replace: true })
      }
    }
  }, [loading, structure, pluginSlug, navigate])

  if (loading) {
    return (
      <div style={{ padding: 48 }}>
        <VStack gap="lg" align="center">
          <Skeleton width={200} height={32} />
          <Skeleton width={400} height={20} />
        </VStack>
      </div>
    )
  }

  if (!structure) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <VStack gap="md" align="center">
          <Text size="lg" weight="medium">Documentation not found</Text>
          <Text color="muted">The requested plugin documentation does not exist.</Text>
        </VStack>
      </div>
    )
  }

  // Show loading while redirecting
  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <VStack gap="md" align="center">
        <Skeleton width={200} height={32} />
        <Text color="muted">Loading documentation...</Text>
      </VStack>
    </div>
  )
}
